if (!customElements.get('shop-by-category')) {
  class ShopByCategory extends HTMLElement {
    connectedCallback() {
      const setBg = (url) => {
        if (url) {
          this.style.setProperty('--sbc-active-bg', `url("${url}")`);
          this.classList.add('sbc-has-active-bg');
        } else {
          this.style.removeProperty('--sbc-active-bg');
          this.classList.remove('sbc-has-active-bg');
        }
      };

      const defaultBg = this.dataset.defaultBg || '';
      // setBg(defaultBg); // keep commented if you only want bg on hover

      this.style.setProperty('--sbc-scroll-progress', '0');

      const updateScrollProgress = () => {
        const rect = this.getBoundingClientRect();
        const vh = window.innerHeight;
        const progress = Math.max(0, Math.min(1, (vh - rect.top) / (vh * 0.8)));
        this.style.setProperty('--sbc-scroll-progress', String(progress));
      };

      let ticking = false;
      const onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            updateScrollProgress();
            ticking = false;
          });
          ticking = true;
        }
      };

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                this.classList.add('sbc-is-visible');
                updateScrollProgress();
              } else {
                this.classList.remove('sbc-is-visible');
              }
            });
          },
          { threshold: 0 }
        );
        io.observe(this);
      } else {
        this.classList.add('sbc-is-visible');
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      updateScrollProgress();

      // Hover/focus swaps the center background + shows panel frame/background
      const links = this.querySelectorAll('.sbc-link[data-bg]');
      const onEnter = (el) => {
        this.classList.add('sbc-panel-hover');
        setBg(el.dataset.bg || defaultBg);
        links.forEach((link) => link.classList.remove('sbc-link-active'));
        if (el) el.classList.add('sbc-link-active');
      };
      const onLeave = () => {
        this.classList.remove('sbc-panel-hover');
        setBg('');
        links.forEach((link) => link.classList.remove('sbc-link-active'));
      };

      links.forEach((a) => {
        a.addEventListener('mouseenter', () => onEnter(a));
        a.addEventListener('focus', () => onEnter(a));
        a.addEventListener('mouseleave', onLeave);
        a.addEventListener('blur', onLeave);
      });

      // First element in hover state on load
      if (links.length) onEnter(links[0]);
    }
  }
  customElements.define('shop-by-category', ShopByCategory);
}

